import React from 'react'

function Visite() {
  return (
    <div>Visite</div>
  )
}

export default Visite